export const DEPARTMENTS = [
  "ऊर्जा विभाग",
  "जलदाय विभाग",
  "जलदाय विभाग (परियोजना)",
  "राजस्व",
  "सार्वजनिक निर्माण विभाग",
  "पुलिस प्रशासन",
  "पशुपालन विभाग",
  "चिकित्सा एवं स्वास्थ्य",
  "सहकारिता",
  "पंचायती राज",
  "सूचना प्रौद्योगिकी",
  "शिक्षा विभाग",
  "ग्रामीण विकास",
  "केंद्र सरकार के विभाग",
  "आरएसएमएम",
  "सीएसआर",
  "मुख्यमंत्री प्रकोष्ठ",
  "ज्ञापन",
  "राजस्थान विधान सभा",
  "चीफ सेक्रेटरी",
  "याचिकाएं",
  "विधान सभा से इतर",
  "समस्त योजनाएं",
];

// Bilingual labels. Keys remain in Devanagari (used as the canonical value
// stored in the database and sent to the API); values below are English
// translations shown when the UI language is set to "en".
export const DEPARTMENT_LABELS_EN = {
  "ऊर्जा विभाग": "Energy Department",
  "जलदाय विभाग": "Water Supply Department (PHED)",
  "जलदाय विभाग (परियोजना)": "Water Supply Department (Projects)",
  "राजस्व": "Revenue",
  "सार्वजनिक निर्माण विभाग": "Public Works Department (PWD)",
  "पुलिस प्रशासन": "Police Administration",
  "पशुपालन विभाग": "Animal Husbandry Department",
  "चिकित्सा एवं स्वास्थ्य": "Medical & Health",
  "सहकारिता": "Cooperation",
  "पंचायती राज": "Panchayati Raj",
  "सूचना प्रौद्योगिकी": "Information Technology",
  "शिक्षा विभाग": "Education Department",
  "ग्रामीण विकास": "Rural Development",
  "केंद्र सरकार के विभाग": "Central Government Departments",
  "आरएसएमएम": "RSMM",
  "सीएसआर": "CSR",
  "मुख्यमंत्री प्रकोष्ठ": "Chief Minister's Cell",
  "ज्ञापन": "Memorandum",
  "राजस्थान विधान सभा": "Rajasthan Legislative Assembly",
  "चीफ सेक्रेटरी": "Chief Secretary",
  "याचिकाएं": "Petitions",
  "विधान सभा से इतर": "Non-Assembly Matters",
  "समस्त योजनाएं": "All Schemes",
};

export function deptLabel(name, lang) {
  if (!name) return "";
  if (lang === "hi") return name;
  return DEPARTMENT_LABELS_EN[name] || name;
}

export const STAGES = [
  "Received",
  "Under Review",
  "Forwarded",
  "In Progress",
  "Field Inspection",
  "Action Taken",
  "Pending",
  "Resolved",
  "Closed",
];

export const STAGE_STYLES = {
  Received: { bg: "#eef2ff", text: "#4f46e5", border: "#c7d2fe" },
  "Under Review": { bg: "#eff6ff", text: "#2563eb", border: "#bfdbfe" },
  Forwarded: { bg: "#f0fdfa", text: "#0d9488", border: "#99f6e4" },
  "In Progress": { bg: "#fffbeb", text: "#d97706", border: "#fde68a" },
  "Field Inspection": { bg: "#f5f3ff", text: "#7c3aed", border: "#ddd6fe" },
  "Action Taken": { bg: "#ecfdf5", text: "#059669", border: "#a7f3d0" },
  Pending: { bg: "#fff1f2", text: "#e11d48", border: "#fecdd3" },
  Resolved: { bg: "#f0fdf4", text: "#16a34a", border: "#bbf7d0" },
  Closed: { bg: "#f8fafc", text: "#475569", border: "#cbd5e1" },
};

export const PRIORITY_STYLES = {
  High: { bg: "#fef2f2", text: "#dc2626" },
  Medium: { bg: "#fffbeb", text: "#d97706" },
  Low: { bg: "#f0fdf4", text: "#16a34a" },
};

export const STATUS_STYLES = {
  Open: { bg: "#ecfdf5", text: "#059669", border: "#a7f3d0" },
  Closed: { bg: "#f1f5f9", text: "#475569", border: "#cbd5e1" },
};

export const PRIORITIES = ["Low", "Medium", "High"];
export const STATUSES = ["Open", "Closed"];
